export default "__VITE_ASSET__54e84e01__"